import { createFeatureSelector, createSelector } from '@ngrx/store';

import { I18nState } from './i18n.reducer';

export const selectI18nState = createFeatureSelector<I18nState>('i18n');

export const language = createSelector(selectI18nState, (i18n) => i18n.language);
export const getLanguages = createSelector(selectI18nState, (i18n) => i18n.languages);
export const getLanguage = createSelector(selectI18nState, (i18n) => i18n.languages.find((lang) => lang.value === i18n.language));
